export default __webpack_public_path__ + "static/media/tick.75cad94d.svg";